<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 设备列表
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <downloadBtn
            url="operation/device/export/exportList"
            :params="seefrom"
            method="post"
            :needUserId="true"
          ></downloadBtn>
          <button class="GreenSmBtn" @click="toAddNew">新增</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="设备名称">
                <el-input placeholder="请输入设备名称" v-model="seefrom.deviceName"></el-input>
              </el-form-item>
              <el-form-item label="设备编码">
                <el-input placeholder="请输入设备编码" v-model="seefrom.device_mark"></el-input>
              </el-form-item>
              <el-form-item label="应用系统" prop="system_id">
                <el-select
                  :popper-append-to-body="false"
                  v-model="seefrom.system_id"
                  placeholder="请选择应用系统"
                  @change="selectDeviceType"
                >
                  <el-option
                    v-for="item in SystemId"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="设备类型">
                <el-select
                  :popper-append-to-body="false"
                  placeholder="请输入设备类型"
                  v-model="seefrom.deviceType"
                >
                  <el-option :value="''">请选择</el-option>
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.typeName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <br />
              <el-form-item label="设备型号">
                <el-input placeholder="请输入设备型号" v-model="seefrom.model"></el-input>
              </el-form-item>
              <el-form-item label="设备状态">
                <el-select
                  placeholder="请输入设备状态"
                  v-model="seefrom.status"
                  :popper-append-to-body="false"
                >
                  <el-option :value="''">请选择</el-option>
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="区域选择">
                <el-input
                  placeholder="请选择区域"
                  v-model="seefrom.curAreaName"
                  @focus="changeAreaMode(1)"
                ></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/device/list"
            :parent="self"
            :config="config"
            :other="other"
            ref="deviceList"
          >
            <template slot="last">
              <el-table-column label="操作" width="380">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconcheck"
                    type="text"
                    size="small"
                    @click="matching(scope.$index, scope.row)"
                    >配比</el-link
                  >
                  <el-link
                    icon="iconfont iconcheck"
                    type="text"
                    size="small"
                    @click="seeAll(scope.$index, scope.row)"
                    >全景</el-link
                  >
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="toEdit(scope.$index, scope.row, true)"
                    >编辑</el-link
                  >
                  <el-link
                    icon="iconfont iconcheck"
                    type="text"
                    size="small"
                    @click="checkParts(scope.row)"
                    >部件
                  </el-link>
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="deleteDevice(scope.$index, scope.row)"
                    >删除</el-link
                  >
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <!-- 弹出框 -->
        <el-dialog
          class="editDialog"
          :visible.sync="displayForm"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form ref="addEquipment" :model="addEquipment" :rules="rules">
            <el-form-item label="应用系统" prop="system_id">
              <el-select
                :popper-append-to-body="false"
                v-model="addEquipment.system_id"
                placeholder="请选择应用系统"
                @change="selectDeviceType"
              >
                <el-option
                  v-for="item in SystemId"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备类型" prop="type">
              <el-select
                :popper-append-to-body="false"
                v-model="addEquipment.type"
                value
                placeholder="请选择设备类型"
                style="width: 100%"
                @change="changeEquipment"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.typeName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系人" prop="username">
              <el-input placeholder="请输入联系人" v-model="addEquipment.username"></el-input>
            </el-form-item>
            <el-form-item v-if="addEquipment.username" label="联系电话" prop="telephone">
              <el-input placeholder="请输入联系电话" v-model="addEquipment.telephone"></el-input>
            </el-form-item>
            <el-form-item
              v-if="this.addEquipment.protocolType === 8"
              label="用户名"
              prop="mqtt_uname"
            >
              <el-input
                placeholder="请输入用户名"
                v-model="addEquipment.mqtt_uname"
                @input="changeEvent($event)"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="this.addEquipment.protocolType === 8" label="密码" prop="mqtt_pwd">
              <el-input
                placeholder="请输入密码"
                v-model="addEquipment.mqtt_pwd"
                @input="changeEvent($event)"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="this.addEquipment.protocolType === 9"
              label="建链方式"
              prop="select_link"
            >
              <el-select v-model="addEquipment.select_link" @change="changeEvent($event)">
                <el-option
                  v-for="item in selectLink"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="this.addEquipment.protocolType === 9 && this.addEquipment.select_link === '0'"
              label="设备服务器地址"
              prop="device_ip"
            >
              <el-input v-model="addEquipment.device_ip" @input="changeEvent($event)"></el-input>
            </el-form-item>
            <el-form-item
              v-if="this.addEquipment.protocolType === 9 && this.addEquipment.select_link === '1'"
              label="注册消息"
              prop="device_ip"
            >
              <el-input
                v-model="addEquipment.register_message"
                @input="changeEvent($event)"
              ></el-input>
            </el-form-item>
            <el-form-item label="设备名称" prop="name">
              <el-input placeholder="请输入设备名称" v-model="addEquipment.name"></el-input>
            </el-form-item>
            <el-form-item label="设备编码" prop="device_mark" v-if="showDeviceMark">
              <el-input
                placeholder="请输入设备编码"
                v-model="addEquipment.device_mark"
                :readonly="inputReadOnly"
              ></el-input>
            </el-form-item>
            <el-form-item class="muti-item" label="生产厂商" prop="factory">
              <el-select
                :popper-append-to-body="false"
                v-model="addEquipment.factoryId"
                value
                placeholder="请选择生产厂商"
                @change="initDeviceMode"
              >
                <el-option
                  v-for="item in factoryList"
                  :key="'F' + item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <!-- <el-input v-model="addEquipment.factory" :readonly="inputReadOnly"></el-input> -->
            </el-form-item>
            <el-form-item class="muti-item" label="设备型号" prop="model">
              <el-select
                :popper-append-to-body="false"
                v-model="addEquipment.pumpType"
                value
                placeholder="请选择设备型号"
                @change="deviceModeChange"
              >
                <el-option
                  v-for="item in deviceModeList"
                  :key="'M' + item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <!-- <el-input v-model="addEquipment.model" :readonly="inputReadOnly"></el-input> -->
            </el-form-item>
            <el-form-item label="设备到期时间" prop="expire_time">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="请选择到期时间"
                v-model="addEquipment.expire_time"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="设备imsi" prop="imsi">
              <el-input
                placeholder="请输入设备imsi"
                v-model="addEquipment.imsi"
                :readonly="inputReadOnly"
              ></el-input>
            </el-form-item>
            <el-form-item label="安装点选择" prop="regionName">
              <el-input
                v-model="addEquipment.regionName"
                placeholder="请选择安装点"
                @focus="changeAreaMode(2)"
              ></el-input>
              <el-input
                v-model="addEquipment.region"
                v-show="false"
                :validate-event="false"
              ></el-input>
            </el-form-item>
            <el-form-item label="安装位置" prop="address">
              <el-input placeholder="请输入安装位置" v-model="addEquipment.address"></el-input>
            </el-form-item>
            <el-form-item label="上传图片">
              <el-upload-secondary
                class="YnormalCard"
                v-model="addEquipment.fileList"
                list-type="picture-card"
                accepts="jpg,jpeg,png"
              >
                <i class="el-icon-plus"></i>
              </el-upload-secondary>
              <div
                class="el-form-item__error"
                v-show="!addEquipment.fileList || addEquipment.fileList.length === 0"
                slot="error"
              >
                请上传图片
              </div>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="displayForm = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitForm">确 定</el-button>
          </div>
        </el-dialog>

        <!-- 新增弹框 -->
        <el-dialog class="editDialog" :visible.sync="addDisplayForm" :title="title1">
          <equipmentListPlus
            v-if="ifSuccess"
            :status="status1"
            :ifSuccess="ifSuccess"
            :id="newAddId"
            v-show="loadingStatus && ifSuccess"
            @fstatus="
              status => {
                status2 = status
              }
            "
          ></equipmentListPlus>
          <div slot="footer" class="dialog-footer" v-if="loadingStatus">
            <el-button
              @click="addDisplayForm = false"
              v-if="status1 == 'loading' || status2 == 'loading'"
              >结束等待</el-button
            >
            <el-button @click="addDisplayForm = fasle" v-else>关闭</el-button>
          </div>
        </el-dialog>

        <!-- 配比弹出框 -->
        <el-dialog
          class="editDialog"
          :visible.sync="matchingDisplayForm"
          :title="title"
          :close-on-click-modal="false"
          width="95%"
        >
          <div>
            <el-table
              class="table_mat"
              :data="matchingDataList"
              highlight-current-row
              style="width: 100%;"
            >
              <el-table-column
                prop="flowName"
                header-align="center"
                align="center"
                label="数据流名称"
              >
              </el-table-column>

              <el-table-column
                prop="unit"
                header-align="center"
                align="center"
                width="80"
                label="单位"
              >
              </el-table-column>
              <el-table-column
                prop="symbol"
                header-align="center"
                align="center"
                width="80"
                label="符号"
              >
              </el-table-column>
              <el-table-column header-align="center" align="center" width="100" label="是否配比">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 1">是</span>
                  <span v-else>否</span>
                </template>
              </el-table-column>
              <el-table-column header-align="center" align="center" label="分子系数">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.numeratorCoefficient" type="number" />
                </template>
              </el-table-column>

              <el-table-column header-align="center" align="center" label="分子常量">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.numeratorConstant" type="number" />
                </template>
              </el-table-column>
              <el-table-column header-align="center" align="center" label="分母系数">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.denominatorCoefficient" type="number" />
                </template>
              </el-table-column>

              <el-table-column header-align="center" align="center" label="分母常量">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.denominatorConstant" type="number" />
                </template>
              </el-table-column>
              <el-table-column header-align="center" align="center" width="350" label="配比规则">
                <template slot-scope="scope">
                  <span
                    >({{ scope.row.numeratorCoefficient }}*x + {{ scope.row.numeratorConstant }}) /
                    ({{ scope.row.denominatorCoefficient }}*x +
                    {{ scope.row.denominatorConstant }})</span
                  >
                </template>
              </el-table-column>
              <el-table-column header-align="center" align="center" width="110" label="操作">
                <template slot-scope="scope">
                  <button class="BlueSmBtn" @click="saveMatching(scope.row)">保存配置</button>
                  <button
                    class="OrangeSmBtn"
                    @click="delMatching(scope.row)"
                    v-if="scope.row.status == 1"
                  >
                    清除配置
                  </button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-dialog>

        <!-- 区域树 -->
        <mountPoint
          :hasChildNodes="areaTreeMode"
          :dialogVisible="areaTreeVisible"
          @regionTreeClose="areaTreeVisible = false"
          @regionTreeData="selRegionData"
        ></mountPoint>
      </el-tab-pane>
    </el-tabs>
    <partsList ref="partsListRef"></partsList>
  </div>
</template>

<script>
  import { dt, obj2urlsp } from 'utils'
  export default {
    data() {
      return {
        ifSuccess: false,
        addDisplayForm: false,
        rules: {
          telephone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
          device_mark: [{ required: true, message: '请输入设备编码', trigger: 'blur' }],
          type: [{ required: true, message: '请输入设备类型', trigger: 'blur' }],
          name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
          system_id: [{ required: true, message: '请输入应用系统', trigger: 'blur' }],
          factory: [{ required: true, message: '请输入生产厂商', trigger: 'blur' }],
          model: [{ required: true, message: '请输入设备型号', trigger: 'blur' }],
          // imsi: [
          //   { required: true, message: "请输入设备IMSI", trigger: "blur" }
          // ],
          regionName: [{ required: true, message: '请选择安装点', trigger: 'blur' }],
          address: [{ required: true, message: '请输入安装位置', trigger: 'blur' }]
        },
        selectLink: [
          { id: '1', label: '设备主动' },
          { id: '0', label: '平台主动' }
        ],
        tabName: 'jsgl',
        loading: true,
        form_jsgl: {},
        editDialogVisible: false,
        showTable: true,
        other: {
          ...this.seefrom
        },
        //弹出框标题
        title: '',
        title1: '设备新增状态',
        //加载标识
        //区域树是否显示
        areaTreeVisible: false,
        inputReadOnly: false,
        //区域树模式选择
        areaTreeMode: true,
        //查询弹框是否显示
        infoDialogVisible: false,
        //选择区域树模式 查询 ？ 新增 ？
        areaMode: 1,
        //设备额外信息
        equipment: {
          protocolTypeName: ''
        },
        //分页
        message: {
          total: 0,
          currentPage: 1,
          pageSize: 10
        },
        //新增修改查看条框是否显示下面的按钮
        seeBtn: true,
        //新增还是修改
        state: null,
        //新增修改弹框是否显示
        displayForm: false,
        // 配比弹出框显示
        matchingDisplayForm: false,
        // 配比弹出框数据列表
        matchingDataList: [],
        matchingDeviceType: null,

        //设备列表数据
        tableData2: [],
        //设备类型数组
        options: [],
        Options: [],
        //通道列表
        channels: [],
        channelsCopy: [],
        //消防泵类型列表 废弃
        pumpTypes: [],
        //设备厂家列表
        factoryList: [],
        //设备型号列表
        deviceModeList: [],
        //数据流列表
        dataFlows: [],
        //DTU列表
        dtuList: [],
        //搜索表单
        seefrom: {
          deviceName: '',
          device_mark: '',
          system_id: '',
          deviceType: '',
          model: '',
          status: null,
          curAreaName: '',
          region_id: ''
        },
        //新增修改查看设备信息
        addEquipment: {
          username: '',
          telephone: '',
          expire_time: '',
          system_id: '',
          id: null,
          name: '',
          device_mark: '',
          model: '',
          type: '',
          deviceType: '',
          factory: '',
          factoryId: null,
          imsi: '',
          region: '',
          regionName: '',
          address: '',
          regions: '',
          selChannel: '',
          pumpType: null,
          dtuId: null,
          //绑定通道
          bindChannels: [],
          protocolType: '',
          //设备协议
          select_link: '',
          device_ip: '',
          register_message: '',
          mqtt_uname: '',
          mqtt_pwd: '',
          fileList: []
        },
        statusOptions: [
          {
            value: 0,
            label: '创建'
          },
          {
            value: 1,
            label: '在线'
          },
          {
            value: 2,
            label: '离线'
          },
          {
            value: 3,
            label: '故障'
          },
          {
            value: 4,
            label: '断电'
          },
          {
            value: 5,
            label: '平台注册中'
          },
          {
            value: 6,
            label: '平台注册失败'
          },
          {
            value: 7,
            label: '等待设备上线'
          },
          {
            value: 8,
            label: '空闲中'
          },
          {
            value: 9,
            label: '工作中'
          }
        ],
        status1: 'loading',
        status2: '',
        loadingStatus: false,
        newAddId: 0,
        items: [],
        SystemId: [],
        //设备种类（网关）
        deviceKind: '',
        showDeviceMark: false
      }
    },
    computed: {
      self() {
        return this
      },
      config() {
        return [
          {
            prop: 'deviceName',
            label: '设备名称'
          },
          {
            prop: 'device_mark',
            label: '设备编码'
          },
          {
            prop: 'deviceTypeName',
            label: '设备类型'
          },
          {
            prop: 'region',
            label: '所属区域'
          },
          {
            prop: 'model',
            label: '设备型号'
          },
          {
            prop: 'factory',
            label: '生产厂商'
          },
          {
            prop: 'deviceStatusName',
            label: '设备状态'
          },
          {
            prop: 'systemName',
            label: '应用系统'
          },
          {
            prop: 'expire_time',
            label: '到期时间'
          }

          // {
          //   prop: (row, column) => row.oildrum.rfid_number + row.oildrum.imei,
          //   label: "随便"
          // }
        ]
      },
      dt() {
        return dt.map(({ label }) => label)
      },
      urls() {
        if (!this.addEquipment.fileList) return
        return this.addEquipment.fileList
        // .map((o) => `http://39.100.67.126:1212/file/${o.response.data[0]}`)
        // .join(";");
      }
    },
    components: {
      partsList: () => import('./components/partsList'),
      normalNav: () => import('public/normalNav'),
      searchForm: () => import('public/searchForm'),
      easyTable: () => import('public/easyTable'),
      mountPoint: () => import('public/mountPoint'),
      equipmentListPlus: () => import('./equipmentListPlus'),
      downloadBtn: () => import('public/download')
    },
    methods: {
      getOwnerName(row, column) {
        if (row.owerVO) {
          return row.owerVO.name
        } else {
          return ''
        }
      },
      changeEvent(e) {
        this.$forceUpdate()
      },

      // 删除配比
      delMatching(row) {
        this.$axiospost('extra/device/delMatching', {
          id: row.id
        }).then(res => {
          if (res.data.status == '10000') {
            this.$message.success('删除成功')
            row.deviceType = this.matchingDeviceType
            this.matching(null, row)
          } else {
            this.$message.warning('删除失败！')
          }
        })
      },
      // 保存配比
      saveMatching(row) {
        this.$axiospost('extra/device/saveMatching', {
          id: row.id,
          deviceId: row.deviceId,
          flowId: row.flowId,
          status: 1,
          numeratorCoefficient: row.numeratorCoefficient,
          numeratorConstant: row.numeratorConstant,
          denominatorCoefficient: row.denominatorCoefficient,
          denominatorConstant: row.denominatorConstant
        }).then(res => {
          if (res.data.status == '10000') {
            this.$message.success('保存成功')
            row.deviceType = this.matchingDeviceType
            this.matching(null, row)
          } else {
            this.$message.warning('保存失败！')
          }
        })
      },
      // 配比
      matching(index, row) {
        this.matchingDisplayForm = true
        this.matchingDeviceType = row.deviceType
        this.$axiosget('extra/device/findMatching', {
          params: {
            deviceId: row.deviceId,
            deviceType: row.deviceType
          }
        }).then(res => {
          this.matchingDataList = res.data.data
        })
      },
      //全景
      seeAll(index, row) {
        this.$router.push({
          path: '/detail',
          query: {
            id: row.id,
            deviceId: row.deviceId,
            deviceType: row.deviceType,
            pname: row.systemName,
            cname: row.deviceTypeName,
            dname: row.deviceName,
            tabName: 0
          }
        })
      },
      checkParts(row) {
        this.$refs.partsListRef.init(row.id)
      },
      // 初始化设备类型列表
      // initDeviceType() {
      //   this.$axiosget("manager/devicetype/list").then(res => {
      //     //console.log(res);
      //     if (res.data.status === 10000) {
      //       this.Options = res.data.data;
      //     } else {
      //       this.Options = [];
      //     }
      //   });
      //   //console.log(this.Options, 111);
      // },
      selectDeviceType(value) {
        this.addEquipment.type = ''
        this.addEquipment.protocolType = ''
        this.$axiosget('manager/operatingSystemApi/getDeviceTypeByOperatingId', {
          params: {
            id: value
          }
        }).then(res => {
          this.options = res.data.data
        })
      },
      initSystemId() {
        //console.log("应用系统");
        this.$axiosget('manager/operatingSystemApi/getOperatingSystemsByCompanyId', {
          params: {
            compayId: localStorage.getItem('companyId')
          }
        }).then(res => {
          this.SystemId = res.data.data
        })
      },
      initDeviceFactory() {
        let params = {
          key: 'FACTORY',
          pageSize: 99,
          pageNum: 1
        }
        this.$axiosget('operation/dictionaryType/queryList', {
          params: params
        }).then(res => {
          if (res.data.status === '10000') {
            this.factoryList = res.data.data.list
          } else {
            this.factoryList = []
          }
        })
      },
      initDeviceMode(factoryID, deviceModeId) {
        this.addEquipment.model = deviceModeId ? this.addEquipment.model : null
        this.addEquipment.pumpType = deviceModeId || null
        let factoryId = factoryID || this.addEquipment.factoryId
        let temp = this.factoryList.find(it => it.id === factoryId)
        if (temp) {
          this.addEquipment.factory = deviceModeId ? this.addEquipment.factory : temp.name
        }
        let params = {
          dicType: this.addEquipment.factoryId
        }
        this.$axiosget('operation/dictionaryData/queryList', {
          params: params
        }).then(res => {
          if (res.data.status === '10000') {
            let list = res.data.data.list
            this.deviceModeList = list
            if (deviceModeId) {
              let model = list.find(it => it.id === deviceModeId)
              if (model) this.addEquipment.model = this.addEquipment.model || model.name
            }
          } else {
            this.deviceModeList = []
          }
        })
      },
      //设备类型选择变更
      changeEquipment(val) {
        this.equipment = this.options.find(e => val === e.id)
        //判断设备种类
        this.deviceKind = this.equipment.deviceKind
        this.addEquipment.protocolType = this.equipment.protocolType
        if (this.equipment.deviceKind === 2) {
          this.showDeviceMark = false
        } else {
          this.showDeviceMark = true
        }

        this.addEquipment.select_link = ''
        this.addEquipment.device_ip = ''
        this.addEquipment.register_message = ''
        this.addEquipment.mqtt_uname = ''
        this.addEquipment.mqtt_pwd = ''
      },
      deviceModeChange() {
        let deviceMode = this.addEquipment.pumpType
        let temp = this.deviceModeList.find(it => it.id === deviceMode)
        if (temp) {
          this.addEquipment.model = temp.name
        }
      },
      //查询设备型号信息
      queryDeviceMode(id) {
        this.$axiosget('operation/dictionaryData/querySingle', {
          params: { id: id }
        }).then(res => {
          if (res.data.status === '10000') {
            let temp = res.data.data
            if (temp.dicTypeId) {
              this.addEquipment.factoryId = temp.dicTypeId
              this.initDeviceMode(temp.dicTypeId, id)
            }
          }
        })
      },
      //搜索
      subSeefrom() {
        //存储
        localStorage.setItem('backsearch_deviceName', this.seefrom.deviceName)
        localStorage.setItem('backsearch_device_mark', this.seefrom.device_mark)
        localStorage.setItem('backsearch_system_id', this.seefrom.system_id)
        localStorage.setItem('backsearch_deviceType', this.seefrom.deviceType)
        localStorage.setItem('backsearch_model', this.seefrom.model)
        localStorage.setItem('backsearch_status', this.seefrom.status)
        localStorage.setItem('backsearch_curAreaName', this.seefrom.curAreaName)
        localStorage.setItem('backsearch_region_id', this.seefrom.region_id)
        this.other = this.seefrom
        this.$refs.deviceList.pageToOne()
        this.$nextTick(this.$refs.deviceList.getData)
      },
      //重置
      reset() {
        // this.seefrom.deviceName = "";
        // this.seefrom.device_mark = "";
        // this.seefrom.value = "";
        // this.seefrom.status = "";
        // this.seefrom.model = "";
        // this.seefrom.curAreaName = "";
        // this.seefrom.region_id = "";
        // this.seefrom.system_id = null;
        this.seefrom = {
          deviceName: '',
          device_mark: '',
          system_id: '',
          deviceType: '',
          model: '',
          status: '',
          curAreaName: '',
          region_id: ''
        }
        this.options = []
      },
      //清空表单数据
      // clearForm() {
      //   if (
      //     (this.status1 === "loading" || this.status2 === "loading") &&
      //     this.loadingStatus
      //   ) {
      //     this.$message.info(
      //       "稍后可以到设备列表查看设备状态，如果设备状态变为在线，则表示设备已正确安装！"
      //     );
      //   }
      //   this.displayForm = false;
      //   this.addDisplayForm = false;
      //   this.loadingStatus = false;
      //   this.status1 = "loading";
      //   if (this.$refs["addEquipment"]) this.$refs["addEquipment"].resetFields();
      // },
      //to新增设备
      toAddNew() {
        this.title = '新增设备信息'
        this.state = 1
        this.inputReadOnly = false
        this.seeBtn = true
        this.equipment = {}
        this.addEquipment = {
          username: '',
          telephone: '',
          id: null,
          name: '',
          device_mark: '',
          model: '',
          type: '',
          deviceType: '',
          factory: '',
          imsi: '',
          region: '',
          regionName: '',
          address: '',
          regions: '',
          selChannel: '',
          pumpType: null,
          dtuId: null,
          //绑定通道
          bindChannels: []
        }
        this.displayForm = true
        if (this.$refs['addEquipment']) this.$refs['addEquipment'].clearValidate()
      },
      //修改设备
      toEdit(index, row, isUpdate) {
        if (row.device_mark != null) {
          this.displayForm = true
        }
        this.title = '修改设备信息'
        this.state = 2
        this.inputReadOnly = isUpdate
        this.seeBtn = isUpdate
        this.showDeviceMark = true
        // let options = this.options;
        // options.forEach(e => {
        //   //console.log(e.id, row.deviceType, 44444444);
        // });

        this.addEquipment = {
          username: row.username,
          telephone: row.telephone,
          id: row.id,
          expire_time: row.expire_time,
          name: row.deviceName,
          device_mark: row.device_mark,
          model: row.model,
          // deviceType: row.deviceTypeName,
          type: row.deviceType,
          factory: row.factory,
          imsi: row.imsi,
          system_id: row.system_id,
          region: row.region_id,
          regionName: row.region,
          address: row.address,
          dtuId: row.dtuId,
          protocolType: row.protocolType,
          pumpType: row.pumpType,
          select_link: String(row.select_link),
          device_ip: row.device_ip,
          register_message: row.register_message,
          bindChannels: [],
          fileList: []
        }
        if (row.pumpType) {
          this.queryDeviceMode(row.pumpType)
        } else {
          this.addEquipment.factoryId = null
          this.addEquipment.pumpType = null
        }
        // if (row.protocolType === 3) {
        //   this.queryChannelsByDeviceId(row.deviceId);
        //   let params2 = {
        //     device_type_id: this.equipment.id,
        //     pageSize: 99
        //   };
        //   this.initDataFlows(params2);
        //   if (isUpdate) this.changeDTU(row.dtuId);
        // }
        // if (this.$refs["addEquipment"]) {
        //   this.$nextTick(() => {
        //     this.$refs["addEquipment"].clearValidate();
        //   });
        // }
        this.$axiosget('manager/operatingSystemApi/getDeviceTypeByOperatingId', {
          params: {
            id: row.system_id
          }
        }).then(res => {
          this.options = res.data.data
        })
        let picArr = []
        if (row.imgUrl != null && row.imgUrl !== '') {
          const imgUrl = row.imgUrl.split(',')
          imgUrl.forEach(item => {
            picArr.push({
              name: item,
              url: item.startsWith('https')
                ? item
                : item.replaceAll(process.env.fileUrl, process.env.SSL_HOST + '/file/')
            })
          })
        }
        this.addEquipment.fileList = picArr
      },
      //新增|修改-提交表单
      submitForm() {
        this.$refs['addEquipment'].validate(valid => {
          if (valid) {
            this.displayForm = false
            //新增
            if (this.state === 1) {
              this.loadingStatus = true
              let file = this.urls
              let ownPicList = []
              if (file) {
                file.forEach(element => {
                  if (element.response.data !== undefined) {
                    // ownPicList.push(process.env.fileUrl + "/" + element.response.data[0]);
                    ownPicList.push(
                      element.response.data[0].startsWith('http')
                        ? element.response.data[0]
                        : process.env.fileUrl + '/' + element.response.data[0]
                    )
                  }
                })
              }
              this.$axiospost('operation/device/add', {
                username: this.addEquipment.username,
                telephone: this.addEquipment.telephone,
                imgUrl: ownPicList.join(','),
                device_kind: this.deviceKind,
                deviceName: this.addEquipment.name.trim(),
                device_mark: this.addEquipment.device_mark.trim(),
                model: this.addEquipment.model.trim(),
                deviceType: this.addEquipment.type,
                system_id: this.addEquipment.system_id,
                factory: this.addEquipment.factory.trim(),
                imsi: this.addEquipment.imsi,
                region_id: this.addEquipment.region,
                address: this.addEquipment.address,
                dtuId: this.addEquipment.dtuId,
                pumpType: this.addEquipment.pumpType,
                bindChannels: this.addEquipment.bindChannels,
                expire_time: this.addEquipment.expire_time,
                protocolType: this.addEquipment.protocolType,
                select_link: this.addEquipment.select_link
                  ? Number(this.addEquipment.select_link)
                  : null,
                device_ip: this.addEquipment.device_ip ? this.addEquipment.device_ip : null,
                register_message: this.addEquipment.register_message
                  ? this.addEquipment.register_message
                  : null,
                mqtt_uname: this.addEquipment.mqtt_uname ? this.addEquipment.mqtt_uname : null,
                mqtt_pwd: this.addEquipment.mqtt_pwd ? this.addEquipment.mqtt_pwd : null
              }).then(res => {
                this.status1 = res.data.status === '10000' ? 'success' : 'fail'
                if (res.data.status === '10000') {
                  this.ifSuccess = true
                  this.subSeefrom()
                  this.addDisplayForm = true
                  //console.log("10000");
                } else if (res.data.status === '90001') {
                  this.$message.error(res.data.message)
                  this.subSeefrom()
                  this.addDisplayForm = false
                  //console.log("90001");
                } else {
                  this.$message.danger('添加失败！')
                  this.addDisplayForm = false
                  //console.log("else");
                }

                this.newAddId = res.data.data
              })
            }
            //修改
            else if (this.state === 2) {
              let ownPicList1 = []
              let file = this.urls
              //console.log(file);
              file.forEach(element => {
                if (element.response === undefined || element.response.status !== -10000) {
                  ownPicList1.push(
                    element.response
                      ? element.response.data[0].startsWith('http')
                        ? element.response.data[0]
                        : process.env.fileUrl + '/' + element.response.data[0]
                      : element.url
                  )
                }
              })
              this.$axiospost('operation/device/update', {
                username: this.addEquipment.username,
                telephone: this.addEquipment.username ? this.addEquipment.telephone : '',
                imgUrl: ownPicList1.join(','),
                id: this.addEquipment.id,
                system_id: this.addEquipment.system_id,
                device_kind: this.deviceKind,
                deviceName: this.addEquipment.name.trim(),
                device_mark: this.addEquipment.device_mark.trim(),
                model: this.addEquipment.model.trim(),
                deviceType: this.addEquipment.type,
                // deviceType: this.addEquipment.deviceType,
                factory: this.addEquipment.factory.trim(),
                imsi: this.addEquipment.imsi,
                region_id: this.addEquipment.region,
                address: this.addEquipment.address,
                dtuId: this.addEquipment.dtuId,
                pumpType: this.addEquipment.pumpType,
                bindChannels: this.addEquipment.bindChannels,
                expire_time: this.addEquipment.expire_time,
                select_link: this.addEquipment.select_link
                  ? Number(this.addEquipment.select_link)
                  : null,
                device_ip: this.addEquipment.device_ip ? this.addEquipment.device_ip : null,
                register_message: this.addEquipment.register_message
                  ? this.addEquipment.register_message
                  : null,
                mqtt_uname: this.addEquipment.mqtt_uname ? this.addEquipment.mqtt_uname : null,
                mqtt_pwd: this.addEquipment.mqtt_pwd ? this.addEquipment.mqtt_pwd : null
              }).then(res => {
                this.$message({
                  type: res.data.status === '10000' ? 'success' : 'error',
                  message:
                    res.data.status === '10000' ? '操作成功!' : res.data.message || '系统异常'
                })
                if (res.data.status === '10000') {
                  this.displayForm = false
                  this.subSeefrom()
                }
              })
            }
          } else {
            return false
          }
        })
      },
      //删除设备
      deleteDevice(index, row) {
        this.$confirm('是否删除该设备？', '删除操作', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        })
          .then(() => {
            this.$axiosdelete('operation/device/delete', {
              params: {
                id: row.id
              }
            }).then(res => {
              if (res.data.status === '10000') {
                this.$message({ type: 'success', message: '删除成功!' })
              }
              this.subSeefrom()
            })
          })
          .catch(() => {})
      },
      //选择区域模式变化
      changeAreaMode(mode) {
        this.areaTreeVisible = true
        if (mode === 1) this.areaTreeMode = true
        if (mode === 2) this.areaTreeMode = false
        this.areaMode = mode
      },
      //区域树选择完回调
      selRegionData(a, ...b) {
        let mode = this.areaMode
        if (mode === 1) {
          this.seefrom.region_id = a.id
          this.seefrom.curAreaName = a.name
        } else if (mode === 2) {
          if (!a.type || a.type !== 1) {
            this.$set(this.addEquipment, 'region', null)
            this.addEquipment.regionName = ''
            return
          }
          this.$set(this.addEquipment, 'region', a.id)
          this.addEquipment.regionName = a.name
        }
      },
      backSearch() {
        //console.log("条件查询");
        this.other = this.seefrom
        // this.$refs.deviceList.pageToOne();
        this.$nextTick(this.$refs.deviceList.getData)
        localStorage.removeItem('backsearch_deviceName')
        localStorage.removeItem('backsearch_device_mark')
        localStorage.removeItem('backsearch_system_id')
        localStorage.removeItem('backsearch_deviceType')
        localStorage.removeItem('backsearch_model')
        localStorage.removeItem('backsearch_status')
        localStorage.removeItem('backsearch_curAreaName')
        localStorage.removeItem('backsearch_region_id')
      }
    },
    mounted() {
      // this.initDeviceList();
      // this.initDeviceType();
      this.initDeviceFactory()
      // this.initDtuList();
      this.initSystemId()
      // this.initPumpType(); 废弃

      if (this.SystemId.length > 0 && this.factoryList.length > 0) {
        this.seefrom.deviceName = localStorage.getItem('backsearch_deviceName')
          ? localStorage.getItem('backsearch_deviceName')
          : ''
        this.seefrom.device_mark = localStorage.getItem('backsearch_device_mark')
          ? localStorage.getItem('backsearch_device_mark')
          : ''
        this.seefrom.system_id = localStorage.getItem('backsearch_system_id')
          ? localStorage.getItem('backsearch_system_id')
          : ''
        this.seefrom.deviceType = localStorage.getItem('backsearch_deviceType')
          ? localStorage.getItem('backsearch_deviceType')
          : ''
        this.seefrom.model = localStorage.getItem('backsearch_model')
          ? localStorage.getItem('backsearch_model')
          : ''
        this.seefrom.status = localStorage.getItem('backsearch_status')
          ? localStorage.getItem('backsearch_status')
          : ''
        this.seefrom.curAreaName = localStorage.getItem('backsearch_curAreaName')
          ? localStorage.getItem('backsearch_curAreaName')
          : ''
        this.seefrom.region_id = localStorage.getItem('backsearch_region_id')
          ? localStorage.getItem('backsearch_region_id')
          : ''
      }

      this.$nextTick(this.backSearch())
    }
  }
</script>

<style lang="less" scoped>
  .content {
    .w_normalNav {
      padding-top: 10px;
      height: 52px;
      position: absolute;
      top: -52px;
      right: 32px;
      // z-index: 99;
    }
    .el-input__inner:focus {
      border: 1px solid #3587c7;
    }
    .el-table__body tr.current-row > td {
      background-color: #234366;
    }
    .el-table tr {
      background-color: #2d374d;
    }
    .el-table th {
      background-color: #2d374d;
    }
    .el-table td {
      background-color: #2d374d;
    }

    .el-table td {
      background-color: #2d374d;
    }
    .cell {
      color: #f2f8fe;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/deviceManagement.vue